import { useUser } from "@/hooks/useUser";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { BusinessDropdown } from "./BusinessDropdown";
import { NavMenu } from "./NavMenu";
import { useTheme } from "@/hooks/useTheme";

export function Header() {
  const { user, isLoading } = useUser();
  const { mode } = useTheme();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  // Hide business dropdown on search detail and stacked results pages
  const showBusinessDropdown =
    !location.pathname.startsWith("/search/") ||
    location.pathname.startsWith("/search/recurring");

  return (
    <header className="border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between gap-2">
        <Link to="/search" className="flex items-center shrink-0">
          <img
            src={
              mode === "dark"
                ? "/static/img/Logo_Transparency_White.png"
                : "/static/img/Logo_Transparency_Black.png"
            }
            alt="Airloom"
            className="h-10 sm:h-12 md:h-14 w-auto"
          />
        </Link>
        <div className="flex items-center gap-2">
          {!isLoading && user && (
            <>
              {showBusinessDropdown && (
                <BusinessDropdown
                  key={user.id}
                  defaultBusinessId={user.default_business?.id ?? ""}
                  defaultLocationId={user.default_location?.id ?? ""}
                />
              )}
              <NavMenu user={user} />
            </>
          )}
        </div>
      </div>
      {error && (
        <Alert variant="destructive" className="mt-2">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
    </header>
  );
}
